import {
  Component,
  inject,
  HostListener,
  Renderer2,
  OnDestroy,
  effect,
  Inject
} from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import {
  LucideAngularModule,
  X,
  Headphones,
  Mail,
  MessageCircle,
  Sparkles,
  ExternalLink,
  ArrowRight,
  ShieldCheck,
  Zap
} from 'lucide-angular';
import { SupportModalService } from '../../services/support-modal.service';

@Component({
  selector: 'app-support-modal',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './support-modal.component.html',
  styleUrl: './support-modal.component.scss'
})
export class SupportModalComponent implements OnDestroy {
  readonly X = X;
  readonly Headphones = Headphones;
  readonly Mail = Mail;
  readonly MessageCircle = MessageCircle;
  readonly Sparkles = Sparkles;
  readonly ExternalLink = ExternalLink;
  readonly ArrowRight = ArrowRight;
  readonly ShieldCheck = ShieldCheck;
  readonly Zap = Zap;

  public readonly supportService = inject(SupportModalService);
  private readonly renderer = inject(Renderer2);

  constructor(@Inject(DOCUMENT) private readonly document: Document) {
    // Sincroniza trava de scroll no body durante a exibição
    effect(() => {
      if (this.supportService.isOpen()) {
        this.renderer.addClass(this.document.body, 'body-modal-open');
      } else {
        this.renderer.removeClass(this.document.body, 'body-modal-open');
      }
    });
  }

  @HostListener('window:keydown.escape', ['$event'])
  onKeydownEscape(event: KeyboardEvent): void {
    if (this.supportService.isOpen()) {
      event.preventDefault();
      this.close();
    }
  }

  onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.close();
    }
  }

  close(): void {
    this.supportService.close();
  }

  irParaUpgrade(): void {
    this.supportService.navegarParaUpgrade();
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(this.document.body, 'body-modal-open');
  }
}
